// extracted by mini-css-extract-plugin
export var calendarBtn = "personal-training-callendar-module--calendar-btn--138f5";
export var calendarHolder = "personal-training-callendar-module--calendar-holder--db7ca";
export var dotHolderDay = "personal-training-callendar-module--dot-holder-day--fef2c";
export var dotHolderFooter = "personal-training-callendar-module--dot-holder-footer--b901f";
export var inputCalendarStyle = "personal-training-callendar-module--input-calendar-style--7ad02";
export var reactCalendar = "personal-training-callendar-module--react-calendar--b9750";